import { z } from "zod";
import { VALIDATION_MESSAGES_CARD, nonDigitGlobalRegex } from "constants/validations";

// Phone Number Schema
export const phoneSchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .refine(
        (val) => {
            const cleaned = val.replace(nonDigitGlobalRegex, "");
            return cleaned.length === 10;
        },
        { message: "Must be 10 digits" }
    )
    .refine(
        (val) => {
            const cleaned = val.replace(nonDigitGlobalRegex, "");
            // NANP validation: first digit must be 2-9, fourth digit must be 2-9
            return /^[2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6}$/.test(cleaned);
        },
        { message: "Invalid phone number format" }
    );

export const optionalPhoneSchema = z
    .string()
    .refine(
        (val) => {
            if (!val) return true;
            const cleaned = val.replace(nonDigitGlobalRegex, "");
            return cleaned.length === 10;
        },
        { message: "Must be 10 digits" }
    )
    .refine(
        (val) => {
            if (!val) return true;
            const cleaned = val.replace(nonDigitGlobalRegex, "");
            // NANP validation: first digit must be 2-9, fourth digit must be 2-9
            return /^[2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6}$/.test(cleaned);
        },
        { message: "Invalid phone number format" }
    )
    .optional();
